var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"filters":_vm.filters,"uri":_vm.uri}})
}
var staticRenderFns = []

export { render, staticRenderFns }